import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Gift, Sparkles } from 'lucide-react'
import Logo from '@/components/ui/logo'

interface CustomerData {
  id: string
  email: string
  full_name: string
  visit_stamps: number
  referral_stamps: number
  total_visits: number
  total_referrals: number
  referral_code: string
  points: number
}

interface WelcomeCardProps {
  customerData: CustomerData
  onViewRewards?: () => void
}

const WelcomeCard = ({ customerData, onViewRewards }: WelcomeCardProps) => {
  const firstName = customerData.full_name?.split(' ')[0] || 'Kunde'
  const nextReward = Math.ceil(customerData.visit_stamps / 10) * 10
  const progressToNextReward = ((customerData.visit_stamps % 10) / 10) * 100

  return (
    <Card className="bg-gradient-to-br from-primary/10 via-background to-accent/10 border-primary/20">
      <CardHeader className="pb-2 sm:pb-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
          <div>
            <CardTitle className="text-base sm:text-xl md:text-2xl">Willkommen zurück, {firstName}!</CardTitle>
            <CardDescription className="text-xs sm:text-sm md:text-base mt-1">
              Ihre digitale Treuekarte bei Herzensempfehlung
            </CardDescription>
          </div>
          <div className="bg-gradient-to-r from-primary to-primary-glow p-2 sm:p-2.5 md:p-3 rounded-full shadow-glow self-start sm:self-center">
            <Logo className="h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8" />
          </div>
        </div>
      </CardHeader>
      
      <CardContent className="space-y-4 md:space-y-6">
        {/* Action Buttons removed per request */}


        {/* Achievement Badges */}
        {(customerData.total_visits >= 50 || customerData.total_referrals >= 10) && (
          <div className="flex flex-wrap gap-2">
            {customerData.total_visits >= 50 && (
              <Badge variant="secondary" className="bg-primary/10 text-primary border-primary/20">
                <Logo size="sm" className="mr-1" />
                Stammkunde
              </Badge>
            )}
            {customerData.total_referrals >= 10 && (
              <Badge variant="secondary" className="bg-accent/10 text-accent border-accent/20">
                <Gift className="h-3 w-3 mr-1" />
                Empfehlungs-Champion
              </Badge>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default WelcomeCard